import React, { useState } from 'react';
import axios from 'axios';
import { usePage } from '@inertiajs/react';
import { CursorPagination } from '@/types';
import Comment from '@/Components/Comment';
import Button from '@/Components/Button';
import IconLoading from '@/svgs/pending-ellipse.svg?react';

export default function Comments({ data }: { data: CursorPagination }) {
  const { version } = usePage();
  const [payload, setPayload] =
    useState<CursorPagination<App.Data.CommentData>>(data);
  const [loading, setLoading] = useState(false);

  function handleClick() {
    setLoading(true);
    axios
      .get(payload.next_page_url, {
        headers: {
          'X-Inertia': true,
          'X-Inertia-Version': version || '',
        },
      })
      .then(response => {
        setPayload({
          ...response.data.props.comments,
          data: [...payload.data, ...response.data.props.comments.data],
        });
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => setLoading(false));
  }
  return (
    <div className="space-y-2 pb-2">
      {payload.data.map((comment, idx) => (
        <Comment
          key={comment.id}
          comment={comment}
          isLast={idx === payload.data.length - 1}
        />
      ))}
      {payload.next_page_url && (
        <div className="flex justify-center pt-5">
          <Button styleType="primary" onClick={handleClick}>
            {loading ? <IconLoading /> : 'Load more comments'}
          </Button>
        </div>
      )}
    </div>
  );
}
